export enum PassOrFail {
    PASS = 'PASS',
    FAIL = 'FAIL',
}

export enum QAQCAnalysisTypeEnum {
    SILK_FIBER_ANALYSIS = 'SILKFIBERANALYSIS',
    SILK_FIBER_LAB_ANALYSIS = 'SILKFIBERLABANALYSIS',

}

export enum QAQCTestTypeEnum {
    LOT = 'LOT',
    WORK_ORDER = 'WORKORDER',
}